import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { routing } from './command.routing';
import { FormsModule } from '@angular/forms';
import { BestSalesComponent } from '@app/components/best-sales/best-sales.component';
import { CarteComponent } from '@app/components/carte/carte.component';
import { SharedModule } from '@app/modules/shared/shared.module';
import { ProductComponent } from '@app/components/carte/product/product.component';
import { MenuComponent } from '@app/components/carte/menu/menu.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { DisableLinkDirective } from '@app/directives/disable-link';
import { EasyzoomDirective } from '@app/directives/easyzoom';
import { PipesModule } from '@app/pipes/pipes.module';
import { PanierModule } from './../panier/panier.module';
import { ProductService } from '@app/services/product/product.service';
import { FamilyService } from '@app/services/family/family.service';
import { MenuService } from '@app/services/menu/menu.service';
import { BestOffersComponent } from '@app/components/best-offers/best-offers.component';
import { AbsolutePathModule } from '@app/pipes/absolute-path/absolute-path.module';
import { CommandComponent } from './command.component';
import { LazyLoadModule } from '@app/directives/app-lazy-load.module';
import { StickyModule } from '@app/directives/sticky.module';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        routing,
        SharedModule,
        NgSelectModule,
        AbsolutePathModule,
        PipesModule,
        PanierModule,
        SharedModule,
        LazyLoadModule,
        StickyModule
    ],
    declarations: [
        CommandComponent,
        BestOffersComponent,
        BestSalesComponent,
        CarteComponent,
        ProductComponent,
        MenuComponent,
        DisableLinkDirective,
        EasyzoomDirective
    ],
    exports: [
    ],
    providers:[
        ProductService,
        MenuService,
        FamilyService
    ]
})

export class CommandModule {

}
